import api from '../../plugins/api';

// GET /crm/cars/getDcList â ÑÐ¿Ð¸ÑÐ¾Ðº Ð´Ð¸Ð»ÐµÑÑÐºÐ¸Ñ ÑÐµÐ½ÑÑÐ¾Ð² Ð´Ð»Ñ Ð²ÑÐ¿Ð°Ð´Ð°ÑÐºÐ¸.
// ÐÐ¿ÑÐ¸Ð¾Ð½Ð°Ð»ÑÐ½ÑÐµ query-Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ: { cityId, mark }
const getDcList = (params) => {
  return api.get('/api/crm/cars/getDcList', params);
};

export default getDcList;
